import { useMutation } from '@tanstack/react-query';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceProfitability = () => {
  return useMutation({
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceProfitability,
  });
};
